export function mod (x, n) {
    return (x % n + n) % n;
}
export default { mod }


// WEBPACK FOOTER //
// ./src/plugins/mod.js